import React, { useContext, useCallback } from 'react';
import { // eslint-disable-line import/no-extraneous-dependencies
  State, PanGestureHandler,
} from 'react-native-gesture-handler';
import { Platform } from 'react-native';

import { DragAndDropContext, STATUS } from '../contexts/DragAndDropContext';
import { ScrollViewContext } from '../contexts/ScrollViewContext';
import { DraggableFlatListContext } from '../contexts/DraggableFlatListContext';
import { logHandlerEvent } from '../utils';


const DraggablePanGestureHandler = ({
  children,
}) => {
  const {
          longPressGestureRef,
          scrollViewGestureRef,
          onPanGestureEvent,
          verticalPanGestureRef,
        } = useContext(DraggableFlatListContext),
        { isUserScrolling, isScrolling } = useContext(ScrollViewContext),
        {
          touchStatus, onPan, reset, onDrop, onDropHorizontal,
        } = useContext(DragAndDropContext),
        onHandlerStateChange = useCallback(({ nativeEvent }) => {
          logHandlerEvent('PanGestureHandler', { nativeEvent });

          if (nativeEvent.state === State.ACTIVE) {
            onPan(nativeEvent);
          }

          if ([
            State.END,
            State.CANCELLED,
            State.FAILED,
          ].includes(nativeEvent.state)
          ) {
            if (touchStatus === STATUS.DRAGGED) {
              onDrop(nativeEvent);
            } else {
              if (touchStatus === STATUS.HORIZONTAL) {
                onDropHorizontal && onDropHorizontal(nativeEvent);
              }
              reset();
            }
          }
        }, [onDrop, onDropHorizontal, onPan, reset, touchStatus]);

  return (
    <PanGestureHandler
      enabled={((!isUserScrolling || Platform.OS === 'android') && !isScrolling) || touchStatus === STATUS.DRAGGED}
      minDist={1}
      onGestureEvent={onPanGestureEvent}
      ref={verticalPanGestureRef}
      reset={reset}
      simultaneousHandlers={[longPressGestureRef, scrollViewGestureRef]}
      touchStatus={touchStatus}
      onHandlerStateChange={onHandlerStateChange}
    >
      {children}
    </PanGestureHandler>
  );
};

export default DraggablePanGestureHandler;
